import { IScope } from 'angular';
import { Subject, takeUntil } from 'rxjs';

export function takeUntilDestroyed<T>($scope: IScope) {
  const destroy$ = new Subject<void>();
  const operator = takeUntil<T>(destroy$);

  $scope.$on('$destroy', () => {
    destroy$.next();
    destroy$.complete();
  });

  return operator;
}
